import { render } from "./AdministratorCreateComponent.vue?vue&type=template&id=48850b22"
import script from "./AdministratorCreateComponent.vue?vue&type=script&lang=js"
export * from "./AdministratorCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/administrators/AdministratorCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48850b22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48850b22', __exports__)) {
    api.reload('48850b22', __exports__)
  }
  
  module.hot.accept("./AdministratorCreateComponent.vue?vue&type=template&id=48850b22", () => {
    api.rerender('48850b22', render)
  })

}


export default __exports__